export interface U2000EmployeeLookupItem {
  codeEmployee?: string;
  firstName?: string;
  lastName?: string;
  isActive?: boolean;
}

export type U2000EmployeeLookupLabelVariant = 'code-dash-name' | 'dash-separated' | 'code-only' | 'name-only';

function appendInactiveSuffix(label: string, isActive: boolean | undefined, inactiveSuffix: string): string {
  if (isActive === false && inactiveSuffix.trim()) {
    return `${label} (${inactiveSuffix.trim()})`;
  }
  return label;
}

function buildEmployeeLabel(item: U2000EmployeeLookupItem, variant: U2000EmployeeLookupLabelVariant): string {
  const code = item.codeEmployee?.trim() ?? '';
  const firstName = item.firstName?.trim() ?? '';
  const lastName = item.lastName?.trim() ?? '';
  const name = `${firstName} ${lastName}`.trim();

  if (variant === 'code-only') {
    return code;
  }

  if (variant === 'name-only') {
    return name || code;
  }

  if (variant === 'dash-separated') {
    return [code, firstName, lastName].filter((part) => part.length > 0).join(' — ');
  }

  if (code && name) return `${code} - ${name}`;
  return code || name;
}

/** Libellé autocomplete / chip employé avec suffixe inactif optionnel (BL-0113 / BL-0114). */
export function u2000FormatEmployeeLookupLabel(
  item: U2000EmployeeLookupItem | null | undefined,
  inactiveSuffix: string,
  variant: U2000EmployeeLookupLabelVariant = 'code-dash-name',
): string {
  if (!item || typeof item !== 'object') return '';
  const label = buildEmployeeLabel(item, variant);
  if (!label) return '';
  return appendInactiveSuffix(label, item.isActive, inactiveSuffix);
}
